import React from 'react'
import { Link } from 'react-router-dom'

const Logo = (props) => {
    const path = window.location.origin + '/svg/' + props.file
    return (
        <div className={`logo ${props.class}`}>
            <Link to="/"><img width={props.width} height={props.height} src={path} alt={props.alt}></img></Link>
        </div>
    )
}

export default Logo
